import humps from "humps";
import { omit } from "lodash-es";
const cleaner = require("deep-cleaner");

export default {
  methods: {
    clevertapAskPushPermission() {
      const locale = this.$store.getters.config.locale;
      const title = { en: "Hungry Hub Updates" };
      title.th = title.en;
      const body = {
        en:
          "Do you want to recieve notifications when we launch new and awesome restaurants/deals?",
        th:
          "คุณต้องการการแจ้งเตือนร้านอาหารใหม่ และ ดีลบุฟเฟ่ต์สุดคุ้มก่อนใคร หรือไม่ ?"
      };
      const okButton = { en: "Yes", th: "ยอมรับ" };
      const rejectButton = { en: "No thanks", th: "ไม่ ขอบคุณ" };
      this.$clevertap.notifications.push({
        titleText: title[locale],
        bodyText: body[locale],
        okButtonText: okButton[locale],
        rejectButtonText: rejectButton[locale],
        okButtonColor: "#f15b5d"
      });
    },
    clevertapPayload() {
      const { currentUser } = this;
      const payload = {
        Name: currentUser.name,
        Email: currentUser.email,
        Phone: currentUser.phone,
        Identity: currentUser.id,
        Gender: currentUser.gender,
        ...omit(currentUser, [
          "name",
          "email",
          "phone",
          "id",
          "gender",
          "birthday"
        ])
      };
      if (currentUser.birthday) {
        payload.DOB = new Date(currentUser.birthday);
      }
      return humps.decamelizeKeys(cleaner(payload), {
        separator: '_',
        process: function (key, convert, options) {
          return ['Name', 'Email', 'Phone', 'Identity', 'Gender'].includes(key) ? key : convert(key, options)
        }
      }
      );
    }
  }
};
